import create from 'zustand';
import { AssessmentType } from '../types';

interface AssessmentState {
  completedAssessments: Record<AssessmentType, boolean>;
  dassResults: {
    depression: { score: number; severity: string };
    anxiety: { score: number; severity: string };
    stress: { score: number; severity: string };
  } | null;
  brsResults: {
    score: number;
    severity: string;
  } | null;
  cissResults: {
    task: { score: number; percentage: number };
    emotion: { score: number; percentage: number };
    avoidance: { score: number; percentage: number };
    primaryStyle: 'task' | 'emotion' | 'avoidance';
  } | null;
  
  setAssessmentComplete: (type: AssessmentType) => void;
  setDassResults: (results: AssessmentState['dassResults']) => void;
  setBrsResults: (results: AssessmentState['brsResults']) => void;
  setCissResults: (results: AssessmentState['cissResults']) => void;
}

export const useAssessmentStore = create<AssessmentState>((set) => ({
  completedAssessments: {
    dass: false,
    brs: false,
    ciss: false
  },
  dassResults: null,
  brsResults: null,
  cissResults: null,

  setAssessmentComplete: (type) => set((state) => ({
    completedAssessments: {
      ...state.completedAssessments,
      [type]: true
    }
  })),

  setDassResults: (results) => set({ dassResults: results }),
  setBrsResults: (results) => set({ brsResults: results }),
  setCissResults: (results) => set({ cissResults: results })
}));